import { CreateMinuteBody } from 'components/minute/layout/CreateMinuteBody';
import { CreateMinuteStyle } from 'components/minute/layout/CreateMinuteStyle';
import { ChooseStyleData } from 'components/minute/layout/CreateMinuteStyle/ChooseMinuteStyle';
import { MinutePageHeader } from 'components/minute/layout/MinutePageHeader';
import { MobileScrollWrapper } from 'components/mobile/MobileScrollWrapper';
import { useCreateMap } from 'hooks/map/useCreateMap';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const CreateMinutePage = (props: Props): JSX.Element => {
    const [flow, setFlow] = useState<'name' | 'style'>('name');
    const [mapName, setMapName] = useState('');

    const navigate = useNavigate();
    const { create } = useCreateMap();
    const ctxEdit = useContext(CtxEdit);

    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.from) {
            window.scrollTo(0, location.state.from.scrollY);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    useEffect(() => {
        ctxEdit.setMapWelcomed(false);
    }, []);

    async function createMap(styleData: ChooseStyleData) {
        const result = await create({
            title: mapName,
            style: styleData.url,
            backgroundImage:
                styleData.type === 'image'
                    ? {
                          url: styleData.imageUrl,
                          coordinates: styleData.coordinates
                      }
                    : null
        });
        const worldMapId = result.data?.createWorldMap?.map?.worldMapId;
        navigate(`/minute/${worldMapId}`);
    }

    return (
        <MobileScrollWrapper>
            <S_CreateMinutePage className={props.className}>
                {flow === 'name' && (
                    <>
                        <S_Center>
                            <MinutePageHeader />
                            <CreateMinuteBody
                                onContinue={(mapName) => {
                                    setMapName(mapName);
                                    setFlow('style');
                                }}
                            />
                        </S_Center>
                        <S_Bg />
                    </>
                )}
                {flow === 'style' && (
                    <CreateMinuteStyle
                        onCreateClicked={(style) => {
                            createMap(style);
                        }}
                    />
                )}
            </S_CreateMinutePage>
        </MobileScrollWrapper>
    );
};

const S_CreateMinutePage = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
    @media only screen and (min-width: 1260px) {
        min-width: 1260px;
    }
`;

const S_Center = styled.div`
    display: flex;
    margin: 40px 0 0 0;
    flex-direction: column;
    z-index: 1;
    @media only screen and (min-width: 1260px) {
        width: 1260px;
    }
`;

const S_Bg = styled.div`
    position: absolute;
    top: 0;
    left: calc(50% - 960px);
    width: 1920px;
    height: 100%;
    z-index: 0;
    background-image: url('https://dvtqxks0zalev.cloudfront.net/app-static/createbg.png');
    background-repeat: no-repeat;
    background-size: auto;
    background-position: top center;
`;
